import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidator, ValidationErrors } from '@angular/forms';
import { Observable, delay, map, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({providedIn: 'root'})
export class CodeCoValidatorService implements AsyncValidator {
  codeTakenError: string | null = null;
  private baseUrl: string = environment.baseUrl;

  constructor ( private http: HttpClient ) {}


  validate(control: AbstractControl<any, any>): Observable<ValidationErrors | null> {
    const codeValue: string = control.value;
    // console.log({codeValue})

    return this.http.get<any[]>(`${this.baseUrl}/centrosOperacion?code=${codeValue}`)
      .pipe(
        map(resp => {
          // console.log('respons',resp)
          if ( resp.length === 1 && resp[0].code === codeValue) {
            this.codeTakenError = `El codigo:${codeValue} ya esta en uso`;
            return  {
              codeTaken: true
            };
          } else {
            this.codeTakenError = null
            return null;
          }

        })).pipe(
          delay(500)
        )
  }

}

